/**
 * @name polylangLangSwitcher
 *
 * @desc Overwrites the static url provided by the Polylang plugin and includes the dynamic parameters generated by the SRP filter.
 *
 * @see {@link https://developer.mozilla.org/es/docs/Web/API/MutationObserver}
 */

 document.addEventListener('DOMContentLoaded', () => {
  // Validate that the SRP container exists.
  if (document.querySelectorAll('.lbx-inventory-container').length > 0) {
    /**
     * @desc Overwrites the static url provided by the Polylang plugin and includes the dynamic parameters generated by the SRP filter.
     * 
     * @var array langSwitcher = Language switch button selector.
     * @var Regexp pattern = Regular expression that captures the given string up to the third interaction of a slash. Example: [https://domain.com/]etc
     * @var switchHostProtocol = Capture the Host + Protocol that has the second language.
     * @var actualSlug = The current URL slug.
     * @var switchSlug = The slug that the URL will change to when switching language
     * @var switchUrl = Replaces the current URL of the language change button with the value of the dynamic URL obtained from the BaseURI, replacing only the Host + Protocol with the corresponding one for the second language.
     *  
     * @return string
     */
    function inventoryLangSwitcher() {
      let langSwitcher = document.querySelectorAll('.lang-item.lang-item-first');
      
      langSwitcher.forEach(btn => {
        let pattern = /^(?:[^\/]*\/){3}\s*/g;
    
        let switchHostProtocol = btn.children[0].attributes.href.value.match(pattern)[0];
        let actualSlug = btn.children[0].attributes.href.baseURI.split('/')[3];
        let switchSlug = btn.children[0].attributes.href.value.split('/')[3];
        
    
        let switchUrl = btn.children[0].attributes.href.value = btn.children[0].attributes.href.baseURI.replace(pattern, switchHostProtocol).replace(actualSlug, switchSlug);
    
        return switchUrl;
      });
    }

    // We also call the function when loading the DOM in case it is a link that is shared and does not activate any of the listeners.
    inventoryLangSwitcher();
    
    /**
     * @desc Listens if any filter input exists and its status changes between unchecked->checked, if true, calls the inventoryLangSwitcher() function.
     * 
     * @var mixed element = Element to listen to.
     *  
     * @return string switchUrl
     */
    function filterCheckboxListener(event){
      let element = event.target;
      
      if(element.tagName == 'INPUT' && element.parentElement.classList.contains('custom-checkbox') ){
        inventoryLangSwitcher();
      }
    }
    document.addEventListener('change', filterCheckboxListener);
    
    // Mutation Observer configuration
    let target = document.querySelector('.lbx-inventory-container');
    let config = { attributes: true, childList: true, characterData: true, subtree: true };

    let observer = new MutationObserver(function() {
      inventoryLangSwitcher();
    });

    observer.observe(target, config);
  }
});
